import {
  FILE_UPLOAD,
  FILE_UPLOAD_FAILURE,
  FILE_UPLOAD_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const fileUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case FILE_UPLOAD:
      return { ...state, loading: true };
    case FILE_UPLOAD_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case FILE_UPLOAD_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default fileUploadReducer;
